import { useMutation } from "react-query";
import { API } from "../api";

export const useUpdateAddress = () => {
  return useMutation(API.updateAddress);
};
